import { Typography } from "@mui/material";
import { ChangingDirectionType } from "../types";

type SelectorButtonContent = {
    content: string;
    direction: ChangingDirectionType;
};

export function SelectorButtonContent({
    content,
    direction,
}: SelectorButtonContent){
    return(
        <>
            <Typography style={{ fontSize: '13px', fontWeight: '600'}}>{content}</Typography>
            <Typography style={{ fontSize: '11px', fontWeight: '700', marginBottom: '3px'}}>
                {
                    direction === ChangingDirectionType.Next ? '↑' : '↓'
                }
            </Typography>
        </>
    )
}